import ptBr from './pt-br';

export default { ptBr };
